import { setTaskDetailSelectedData  as setTaskDetailSelectedDataDiagram} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';


export type Row = [];

export type GridRow = Row & { id: number }

export type SetVariantSlicerSelectedDataProps = ApiMethodBase & {
    selection: Row[];
};

export const setTaskDetailSelectedData = ({
    selection,
    eventEmitter,
}: SetVariantSlicerSelectedDataProps) => {
    setTaskDetailSelectedDataDiagram(selection);
};
